export default __webpack_public_path__ + "static/media/GM_Cup_Fire.ad95d4f8.png";